import { all }      from 'redux-saga/effects'
import sendEmailSaga from './sagas/SendEmailSaga'

export default function* contactSagas() {
  yield all([
		sendEmailSaga()
	])
}
